import React, {useContext,useEffect,useState} from 'react'
import { formularioContext } from '../contextos/FormularioContext'
import {ETMostrarDatosVenta} from './ETMostrarDatosVenta'
import {Typography, Box} from '@mui/material'

export const ETMostrarDatosVentaCont = ({item_a_pagar,
                                        venta,
                                        descripcionProvincia,
                                        datosMinistroUad})=>{
    const {grupo,infoMinistro} = useContext(formularioContext)

        return <Box sx={{mt:2}}>
                            <ETMostrarDatosVenta venta={venta} 
                                                item_a_pagar={item_a_pagar}
                                                descripcionProvincia={descripcionProvincia} 
                                                datosMinistroUad={datosMinistroUad}
                                                email_default={venta?.ministroUad==='ministrouad' ? infoMinistro?.email : `${venta?.email}`}
                                                />                                                
                            {grupo.map((group,index)=>{
                                 return <ETMostrarDatosVenta 
                                        venta={group} 
                                        descripcionProvincia={descripcionProvincia}
                                        index={index}
                                        item_a_pagar={item_a_pagar}
                                        matrimonio={item_a_pagar?.matrimonio}
                                        esUltimo = {grupo.length==index+1}
                                        />                                 
                            })}                    
                        </Box>
}

